export default "/images/message-circle.svg?fbde618f916e886eb639e764d3adac72";